import { OrderItem } from '../models/OrderItem'
import { User } from '../models/User'

import { NetworkService } from '../services/NetworkService'

interface IOrder {
  statusId: number
  customerId: number
  sellerId?: number
  dealerId: number
  subtotal: number
  total: number
  tax: number
  profit?: number
  orderItems: OrderItem[]
  seller?: User
  customerNotes?: string
  dealerNotes?: string
}

export class Order implements IOrder {
  statusId!: number
  customerId!: number
  sellerId!: number
  dealerId: number
  subtotal!: number
  total!: number
  profit!: number
  tax!: number
  orderItems!: OrderItem[]
  seller!: User
  customerNotes!: string
  dealerNotes!: string

  constructor(params: IOrder) {
    Object.assign(this, params)
  }

  public static async pushOrder(order: Order) {
      const res = await NetworkService.post(
        process.env.VUE_APP_API_BASE_URL + 
        '/api/v1/auth/orders', order
      )
      return Promise.resolve(res)
  }

  public static async updateOrder(order: any) {
    const res = await NetworkService.patch(
      process.env.VUE_APP_API_BASE_URL +
      '/api/v1/auth/orders/' + order.id, order
    )

    return res
  }

  public static async deleteOrder(order: any) {
    const res = await NetworkService.delete(
      process.env.VUE_APP_API_BASE_URL + 
      '/api/v1/auth/orders/deleteOrder/' + order.id
    )

    return res
  }

  public static async getOrders(userId: (number | null) = null, dealerId: (number | null) = null, startDate: (string | null) = null, endDate: (string | null) = null) {
    const orders : Order[] = []

    const res = await NetworkService.get(
      process.env.VUE_APP_API_BASE_URL +
      '/api/v1/auth/orders?user_id=' + userId + '&dealerId=' + dealerId + '&startDate=' + startDate + '&endDate=' + endDate
    )

    res.data.forEach((t: any) => {
      const order: Order = new Order(t)
      orders.push(order)
    })

    return orders
  }

  public static async getDealerOrders(dealerId: number, startDate: (string | null) = null, endDate: (string | null) = null, options: any, search: string) {
    const orders: Order[] = [] 

    // let order = options.sortDesc[0] === true ? 'desc' : 'asc'
    // let sortBy = options.sortBy[0] === undefined ? 'updated_at' : options.sortBy[0]

    let order = 'desc'
    let sortBy = 'updated_at'

    let res = await NetworkService.get(
      process.env.VUE_APP_API_BASE_URL +
      '/api/v1/auth/orders/getDealerOrders?dealerId=' + dealerId +
      '&page=' + options.page + 
      '&rows=' + 10 +
      '&sortBy=' + sortBy + 
      '&order=' + order +
      '&search=' + search +
      '&startDate=' + startDate + 
      '&endDate=' + endDate
    )


    res.data.data.forEach((ord : any) => {
      let order : Order = new Order(ord)
      orders.push(order)
    })

    return {
      data: orders,
      total: res.data.total
    }
  }
}